import { Injectable } from '@angular/core';
import {
  ChildActivationEnd,
  ChildActivationStart,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
  RoutesRecognized,
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NavService {
  public isLoading: boolean = false;
  public errorMessage: string = '';
  public showMenu = true;
  constructor(public router: Router) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.isLoading = true;
        if (event.url === '/home') {
          this.showMenu = false;
        } else {
          this.showMenu = true;
        }
      } else if (event instanceof RoutesRecognized) {
      } else if (event instanceof RouteConfigLoadStart) {
      
      } else if (event instanceof RouteConfigLoadEnd) {
      } else if (event instanceof NavigationEnd) {

        this.isLoading = false;
      } else if (event instanceof NavigationCancel) {
        this.isLoading = false;
        this.errorMessage = 'Navigation cancelled';
      } else if (event instanceof NavigationError) {
        this.isLoading = false;
        this.errorMessage = 'Navigation error';
      } else if (event instanceof ChildActivationStart) {
        const childRoute = event.snapshot.routeConfig?.path;
        // Load data specific to the child component here
      } else if (event instanceof ChildActivationEnd) {
        // Perform any necessary cleanup tasks here
      }
    });
  }
}
